import React, { Component } from 'react';
import { Button } from 'reactstrap';
// <img src={this.props.imgsrc} alt={this.props.imgsection} />
class SideBarBtn extends Component {
  render() {
    return (
      <div
        className={this.props.addClass}
        id={this.props.imgsection}
        onClick={() => {
          window.scrollTo(0,0);
          this.props.changeSection(this.props.targetSection);
        }}
      >
        {this.props.targetSection}
      </div>
    );
  }
}

export default SideBarBtn;



// WEBPACK FOOTER //
// ./src/components/SideBarBtn.js